<div class="delete_epod_main">
    
    <div class="deleteimg">
        <img src="assets/Delete-Icon.svg">
    </div>
    <div class="modal-column">
        <div class="modal-body">
            Are you sure you want to delete this ePOD?
        </div>

        <div class="modal-footer">
            <div type="button" class="btn btn-secondary" (click)="close()">Cancel</div>
            <div type="button" class="btn btn-primary" (click)="deleteEpod()">Delete</div>
        </div>
    </div>  
</div>